module.exports = __webpack_public_path__ + "static/media/abdominal-pain.1bca79b8.svg";